const PASSWORD_MIN_LENGTH = 8

export  const ruleRequired = (v:string,error:string="Mandatory field") => {
  return !!v || error
}

export const ruleMinLength = (v:string,length:number,fieldName='Fiels') => {
  return v.length >= length || `${fieldName} must have at least ${length} characters`
}

export const rulePasswordMinLength = (v:string,length:number=PASSWORD_MIN_LENGTH) => {
  return  ruleMinLength(v,length,'Password')
}

export const ruleMatch = (v:string,verif:string,fieldName='Fields') => {    
  return verif == v || `${fieldName} must match`   
}

export const ruleMailMatch = (v:string,verifMail:string) => {    
  return ruleMatch(v,verifMail,'Emails')
}

export const rulePasswordMatch = (v:string,verifPass:string) => {    
  return ruleMatch(v,verifPass,'Passwords')
}

export const ruleMailValid = (v:string) => {    
  return /(.+)@(.+){2,}\.(.+){2,}/.test(v) || "The email format is invalid"
}